import React, { ReactElement } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button } from 'idsk-react-components';
import { sendBezPripomienok } from '../../../client/sendBezPripomienokClient';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import './dropdownListButtons.scss';
import sendWithout from '../icons/notes-off.svg';
import UserRole from '../../../model/currentuser/UserRole';
import Secured from '../../Secured';
import { useUserContext } from '../../../context/UserContext';
import routes from '../../../routing/routes';
import { canSendWithoutPripomienky } from '../../../function/permissions';

interface Props {
  reloadSubjektBezPripomienokList(): void;
  reloadFilterData(): void;
  setOpenDropdown: (open: boolean) => void;
}

const SendBezPripomienokButton = ({
  reloadSubjektBezPripomienokList,
  reloadFilterData,
  setOpenDropdown,
}: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { displaySuccess } = useSuccessMessageContext();
  const { wrapClient: sendBezPripomienokClient, status } = useClient(sendBezPripomienok);
  const { pouzivatel, legislationProcess, fetchProfile } = useUserContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onSentBezPripomienok = async (): Promise<void> => {
    setOpenDropdown(true);
    await sendBezPripomienokClient(type, year, index);
    fetchProfile(type, year, index);
    if (!pathname.endsWith('zobraz')) {
      navigate(routes.pripomienky.list.withParams(type, year, index));
    } else {
      reloadSubjektBezPripomienokList();
      reloadFilterData();
    }
    displaySuccess('Odoslanie bez pripomienok bolo úspešné.');
  };
  return (
    <Secured
      allowForRoles={[UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.ODOSIELATEL]}
      additionalCheck={canSendWithoutPripomienky(pouzivatel, legislationProcess)}
    >
      <li key="Odoslať bez pripomienok" className="action-item">
        <div className="icon-wrapper">
          <img src={sendWithout} className="icon" alt="Odoslať bez pripomienok" />
        </div>
        <ConfirmModal
          question={"Naozaj si želáte odoslať za vašu organizáciu spôsobom 'bez pripomienok'? "
            + 'Po potvrdení tejto voľby už nebude možné za vašu organizáciu pridať pripomienku.'}
          cancelButtonText="Nie"
          confirmButton={(<Button buttonStyle="action" size="large">Áno</Button>)}
          openButton={(
            <button
              disabled={status.loading}
              className="button-inline-text send-without-comments-button idsk-link"
              type="button"
            >Odoslať bez pripomienok
              {status.loading ? <FontAwesomeIcon className="spinner" icon={faSpinner} spin /> : null}
            </button>
          )}
          doAfterConfirm={onSentBezPripomienok}
        />
      </li>
    </Secured>
  );
};
export default SendBezPripomienokButton;
